import {
  provideTransloco,
  TRANSLOCO_LOADER,
  TranslocoModule,
} from '@jsverse/transloco';
import { NgModule } from '@angular/core';
import { I18nHttpLoaderService } from '@boels/helpers';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { AVAILABLE_LANGUAGES, LanguageEnum } from '@boels/models';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: AVAILABLE_LANGUAGES,
        defaultLang: LanguageEnum.DEFAULT,
        reRenderOnLangChange: true,
        prodMode: true,
        fallbackLang: LanguageEnum.FALLBACK,
        failedRetries: 2,
      },
      loader: I18nHttpLoaderService,
    }),
    provideTranslocoMessageformat(), // Must be provided after the transloco provider
    {
      provide: TRANSLOCO_LOADER,
      useClass: I18nHttpLoaderService,
    },
  ],
})
export class I18nRootModule {}
